import React, { useRef, useState } from "react";
import {  forwardRef, useImperativeHandle } from "react";
import RadioButtonCheckBox from "components/radioButton/RadioButtonCheckBox";


type PlaceDetails = {
  city: string;
  street: string;
  lat: number | null;
  lng: number | null;
};

type Props = {
  onPlaceSelected: (details: PlaceDetails) => void;
  isEnabled: boolean;
  setIsEnabled: React.Dispatch<React.SetStateAction<boolean>>;
  setIsValidAddress: React.Dispatch<React.SetStateAction<boolean>>;
  disabled?: boolean;
};


const getSearchApiUrl = (): string => {
  try {
    const hostname = window.location.hostname.toLowerCase();
    if (hostname.includes("infodev")) {
      return "infodevsearchapi.leumit.co.il";
    }
    if (hostname.includes("infoqa")) {
      return "infoqasearchapi.leumit.co.il";
    }
    return "infosearchapi.leumit.co.il";
  } catch {
    return "infosearchapi.leumit.co.il";
  }
};

const SEARCH_API_URL = getSearchApiUrl();

//const SEARCH_API_URL = infosearchapi.leumit.co.il;

//infodevsearchapi.leumit.co.il
//infoqasearchapi.leumit.co.il
//infosearchapi.leumit.co.il

export type SearchAdressMedicalCentersHandle = {
  clear: () => void;
};


const SearchAdressMedicalCenters = forwardRef<SearchAdressMedicalCentersHandle, Props>(({ onPlaceSelected, isEnabled, setIsEnabled, setIsValidAddress, disabled = false }, ref) => {  

  const [, setIsFocused] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [suggestions, setSuggestions] = useState<any[]>([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  function generateSessionToken() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
    return Math.random().toString(36).substring(2) + Date.now().toString(36);
  }
  const [sessionToken, setSessionToken] = useState(generateSessionToken());

  const inputRef = useRef<HTMLInputElement>(null);
  const [, setDetails] = useState<PlaceDetails>({
    city: "",
    street: "",
    lat: null,
    lng: null,
  });

  // Fetch suggestions from backend
  const fetchSuggestions = async (input: string) => {
    if (!input) {
      setSuggestions([]);
      return;
    }
    try {
      //const res = await fetch(`https://infodevsearchapi.leumit.co.il/api/search/google/autocomplete?input=${encodeURIComponent(input)}&sessionToken=${sessionToken}`);
      const res = await fetch(`https://${SEARCH_API_URL}/api/search/google/autocomplete?input=${encodeURIComponent(input)}&sessionToken=${sessionToken}`);
      
      if (!res.ok) throw new Error("Failed to fetch suggestions");
      const data = await res.json();
      setSuggestions(data || []);
    } catch (err) {
      setSuggestions([]);
    }
  };

  // Handle input change
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value);
    setIsValidAddress(false);
    setDetails({ city: "", street: "", lat: null, lng: null });
    onPlaceSelected({ city: "", street: value, lat: null, lng: null });
    setShowSuggestions(true);
    fetchSuggestions(value);
  };

  // Handle suggestion click
  const handleSuggestionClick = async (suggestion: any) => {
    setInputValue(suggestion.description);
    setShowSuggestions(false);
    // Fetch lat/lng from backend
    try {
    
      //const res = await fetch(`https://infodevsearchapi.leumit.co.il/api/search/google/place-location?placeId=${encodeURIComponent(suggestion.placeId)}&sessionToken=${sessionToken}`);
      const res = await fetch(`https://${SEARCH_API_URL}/api/search/google/place-location?placeId=${encodeURIComponent(suggestion.placeId)}&sessionToken=${sessionToken}`);
    

      if (!res.ok) throw new Error("Failed to fetch place details");
      const data = await res.json();
      const lat = data.lat ?? null;
      const lng = data.lng ?? null;
      const newDetails = { city: "", street: suggestion.description, lat, lng };
      setDetails(newDetails);
      onPlaceSelected(newDetails);
      setIsValidAddress(true);
    } catch (err) {
      setIsValidAddress(false);
    }
    // Reset session token for next search session
    setSessionToken(generateSessionToken());
  };

  const handleClearInput = () => {
    setInputValue("");
    setSuggestions([]);
    setShowSuggestions(false);
    setIsValidAddress(false);
    setDetails({ city: "", street: "", lat: null, lng: null });
    onPlaceSelected({ city: "", street: "", lat: null, lng: null });
    inputRef.current?.focus();
  };

useImperativeHandle(ref, () => ({
  clear() {
    setInputValue("");
    setSuggestions([]);
    setShowSuggestions(false);
    setIsValidAddress(false);
    setDetails({ city: "", street: "", lat: null, lng: null });
    onPlaceSelected({ city: "", street: "", lat: null, lng: null });
  },
}));

const highlightMatch = (text: string, query: string) => {
  if (!query) return text;
  const normalizedQuery = query.trim();
  if (!normalizedQuery) return text;

  const escaped = normalizedQuery.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const parts = text.split(new RegExp(`(${escaped})`, "gi"));

  return parts.map((part, i) =>
    part.toLowerCase() === normalizedQuery.toLowerCase() ? (
      <span key={i} style={{ color: "#9D3F82" }}>
        {part}
      </span>
    ) : (
      part
    )
  );
};


  React.useEffect(() => {
    if (!isEnabled && inputRef.current) {
      setInputValue("");
      setDetails({ city: "", street: "", lat: null, lng: null });
      onPlaceSelected({ city: "", street: "", lat: null, lng: null });
    }
  }, [isEnabled, onPlaceSelected]);


  return (
    <div
      style={{
        direction: "rtl",
        fontFamily: "Rubik, Arial, sans-serif",
        backgroundColor: "transparent",
        minHeight: 60,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        
      }}
    >
      <div style={{ 
  pointerEvents: disabled ? 'none' : 'auto',  
  opacity: disabled ? 0.5 : 1,  
  cursor: disabled ? 'not-allowed' : 'pointer' 
}}>
      <RadioButtonCheckBox
        label="בכתובת או בקרבתה"
        id="addressRadio"
        value="address"
        isSelected={isEnabled && !disabled}
        name="addressRadio"
        //onSelecteRadio={() => setIsEnabled((prev) => !prev)}
        
        //onSelecteRadio={() => {
        // if (isEnabled && inputRef.current) {
        //   inputRef.current.value = ""; // Clear input when disabling
       //  }
        //  setIsEnabled((prev) => !prev);
        onSelecteRadio={() => {
          if (disabled) return;  
          if (isEnabled && inputRef.current) {
            inputRef.current.value = ""; // Clear input text
            setDetails({ city: "", street: "", lat: null, lng: null }); // Reset details state
            onPlaceSelected({ city: "", street: "", lat: null, lng: null }); // Notify parent
          }
          setIsEnabled((prev) => !prev);
        }}
      />
      </div>


      <div
        tabIndex={0}
        style={{
          width: "100%",
          background: !isEnabled
            ? "linear-gradient(-180deg, #fff, #d6d6da)"
            : "white",
          borderTopRightRadius: 30,
          borderTopLeftRadius:  30,
          borderBottomLeftRadius: showSuggestions && suggestions.length > 0 ? 0 : 30,
          borderBottomRightRadius: showSuggestions && suggestions.length > 0 ? 0 : 30,
          padding: "5px 8px",
          boxSizing: "border-box",
          display: "flex",
          alignItems: "center",
          minHeight: "46px",
          border: isEnabled ? "2px solid #000" : "none",
          position: "relative", // Make parent relative for absolute dropdown
        }}
      >
        <input
          ref={inputRef}
          type="text"
          disabled={!isEnabled || disabled}
          placeholder="יש להקליד כתובת"
          value={inputValue}
          onChange={handleInputChange}
          style={{
            width: "100%",
            minWidth: "50px",
            background: "transparent",
            outline: "none",
            fontFamily: "Rubik, Arial, sans-serif",
            fontSize: 16,
            color: "var(--text, #4d4056)",
            padding: "0 0 0 28px",
            textAlign: "right",
            border: "none",
            borderRadius: 30,
          }}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
          className={isEnabled ? "custom-placeholder-color" : "custom-placeholder-color-disabled"}
          autoComplete="off"
        />
        {isEnabled && !disabled && inputValue && (
          <button
            type="button"
            onMouseDown={(e) => e.preventDefault()}
            onClick={handleClearInput}
            aria-label="ניקוי חיפוש"
            style={{
              position: "absolute",
              left: 10,
              top: "50%",
              transform: "translateY(-50%)",
              width: 20,
              height: 20,
              border: "none",
              background: "transparent",
              padding: 0,
              margin: 0,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg className="ais-SearchBox-resetIcon" viewBox="0 0 20 20" width="10" height="10" aria-hidden="true">
              <path d="M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z" />
            </svg>
          </button>
        )}
        {showSuggestions && suggestions.length > 0 && (
          <ul
            style={{
              position: "absolute",
              zIndex: 1000,
              background: "white",
              width: "100%",
              left: 0,
              right: 0,
              top: "100%",
              margin: 0,
              padding: 0,
              listStyle: "none",
              border: "1px solid #c1d5e7",
              borderTop: "1px solid #000",
              borderRadius: "0 0 18px 18px",
              boxShadow: "0 8px 24px 0 rgba(90, 94, 154, 0.12)",
              maxHeight: 200,
              overflowY: "auto",
              boxSizing: "border-box",
            }}
          >
            {suggestions.map((s, idx) => (
              <li
                key={s.placeId || idx}
                style={{
                  padding: "9px 13px",
                  cursor: "pointer",
                  color: "#4f505e",
                  background: "white",
                  fontSize: 16,
                  transition: "background 0.2s",
                  boxSizing: "border-box",
                  fontWeight: 500,
                }}
                onMouseDown={() => handleSuggestionClick(s)}
                onMouseEnter={e => (e.currentTarget.style.background = "#f3eafd")}
                onMouseLeave={e => (e.currentTarget.style.background = "white")}
              >
                {highlightMatch(s.description, inputValue)}
              </li>
            ))}
          </ul>
        )}
        <style>{`
          .custom-placeholder-color::placeholder {
            color: #5a5e9a !important;
            opacity: 1;
          }
          .custom-placeholder-color-disabled::placeholder {
            color: #5a5e9a !important;
            opacity: 0.4;
          }
        `}</style>
      </div>
    </div>
  );
}
);

export default SearchAdressMedicalCenters;